// src/components/PreserveQueryParams.js
import React, { useEffect } from "react"
import { navigate } from "gatsby"

const PreserveQueryParams = ({ children }) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const msParam = params.get("ms")
    if (!msParam) return

    const handleClick = (e) => {
      if (e.metaKey || e.ctrlKey) return   // allow cmd/ctrl+click
      const link = e.target.closest("a")
      if (!link) return

      const href = link.getAttribute("href")
      if (
        !href ||
        !href.startsWith("/") ||          // only internal
        href.startsWith("//") ||           // not protocol-relative
        href.includes("ms=")               // already has it
      ) {
        return
      }

      e.preventDefault()
      const sep = href.includes("?") ? "&" : "?"
      navigate(`${href}${sep}ms=${msParam}`)
    }

    document.addEventListener("click", handleClick)
    return () => document.removeEventListener("click", handleClick)
  }, [])

  return <>{children}</>
}

export default PreserveQueryParams